import { takeLatest, call, put } from 'redux-saga/effects';
import { callWithAuth } from '../sagaApiHelper';
import { downloadInvoiceApi, getPastTransactionsApi } from '../../api/apiLists/invoiceApi';
import { transformTransactionToInvoice } from '../../utils/transactionUtils';
import { showAlert } from '../alertSlice';
import {
  downloadInvoiceRequest,
  downloadInvoiceSuccess,
  downloadInvoiceFailure,
  getPastTransactionsRequest,
  getPastTransactionsSuccess,
  getPastTransactionsFailure,
} from '../invoiceSlice';

function* handleApiFailure(failureAction, errorOrMessage, fallbackMessage) {
  const message = typeof errorOrMessage === 'string'
    ? errorOrMessage
    : errorOrMessage?.message || fallbackMessage;
  yield put(failureAction(message));
  yield put(showAlert({ message, type: 'error' }));
}

export function* handleDownloadInvoice(action) {
  try {
    yield put(downloadInvoiceRequest());

    const payload = {
      companyId: action.payload.companyId,
      invoiceId: action.payload.invoiceId,
    };

    const res = yield call(callWithAuth, downloadInvoiceApi, payload);
    console.log(res)

    if (res?.downloadUrl) {
      yield put(downloadInvoiceSuccess({
        downloadUrl: res.downloadUrl,
        invoiceFilename: `${res.invoiceNumber || 'invoice'}.pdf`,
      }));

      yield put(showAlert({
        message: 'Invoice ready for download',
        type: 'success',
      }));
    } else {
      yield* handleApiFailure(
        downloadInvoiceFailure,
        'No download URL received from server',
        'Failed to download invoice. Please try again.'
      );
    }
  } catch (error) {
    yield* handleApiFailure(
      downloadInvoiceFailure,
      error,
      'Failed to download invoice. Please check your connection and try again.'
    );
  }
}
export function* handleGetPastTransactions(action) {
  try {
    yield put(getPastTransactionsRequest());
    
    const payload = action.payload || {};
    const res = yield call(callWithAuth, getPastTransactionsApi, payload);

    if (res && res.transactions) {
      const transactions = res.transactions || [];
      const transformedInvoices = transactions.map(transformTransactionToInvoice);
      
      yield put(getPastTransactionsSuccess({
        transactions: transformedInvoices,
        hasMore: res.hasMore,
        nextKey: res.nextKey,
        count: res.count,
      }));
    } else {
      yield* handleApiFailure(
        getPastTransactionsFailure,
        res?.message || 'Invalid response format',
        'Failed to load transaction history. Please try again.'
      );
    }
  } catch (error) {
    yield* handleApiFailure(
      getPastTransactionsFailure,
      error,
      'Failed to load transaction history. Please check your connection and try again.'
    );
  }
}

export default function* invoiceSaga() {
  yield takeLatest('DOWNLOAD_INVOICE', handleDownloadInvoice);
  yield takeLatest('GET_PAST_TRANSACTIONS', handleGetPastTransactions);
}
